import { Action } from "@ngrx/store";
import { BreadcrumbCountryInfoType, BreadcrumbCountryInfoAction } from "@store/actions/breadcrumbInfo.action";
import { BreadcrumbCountryInfo } from "@store/models/breadcrumbInfo.model";

const initialState: BreadcrumbCountryInfo = {
	flag: "",
	clientCountryList: [],
	selectedCountry: "",
	selectedCountryId: ""
};

export const breadcrumbCountryInfoReducer = (state = initialState, action: Action): BreadcrumbCountryInfo => {
	const selectAction = action as BreadcrumbCountryInfoAction;

	switch (selectAction.type) {
		case BreadcrumbCountryInfoType.SET_SELECTED:
			return {
				...state,
				flag: selectAction.payload.flag,
				clientCountryList: selectAction.payload.clientCountryList,
				selectedCountry: selectAction.payload.selectedCountry,
				selectedCountryId: selectAction.payload.selectedCountryId
			};
		default:
			return state;
	}
};
